import Icon from '@/components/snippets/icon/icon'
import { useMobileFiltersContext, ON_BOARDING_STATES } from './OnboardingContext'
import { accountTranslations } from '../helpers/translations'
const NEXT_STEP = ON_BOARDING_STATES.ABOUT

export function OnBoardingInit({ handleView }) {
  const context = useMobileFiltersContext()

  return (
    <div className={'flex flex-col items-center gap-8'}>
      <div className={'aspect-1 max-h-80'}>
        <div class={'flex justify-center'}>
          <Icon id="fit-club-logo" className="h-[13rem] min-w-[15rem] md:h-[20.75rem] md:min-w-[21.0625rem]" viewBox="0 0 209 208" />
        </div>
      </div>

      <div className={'w-full max-w-[452px] text-center'}>
        {accountTranslations.onboarding.title}
      </div>

      <div className={'flex w-full max-w-[402px] flex-col gap-4'}>
        <button
          className={'btn btn-lg btn-solid-accent w-full'}
          onClick={() => {
            context.handleNextStep(NEXT_STEP)
          }}
        >
          {accountTranslations.onboarding.cta}
        </button>
        <button
          className={'btn w-full p-3 text-primary-black underline'}
          onClick={() => {
            handleView()
          }}
        >
          {accountTranslations.onboarding.skip}
        </button>
      </div>
    </div>
  )
}
